import { render, staticRenderFns } from "./orderImport.vue?vue&type=template&id=0a6fe2a5&scoped=true&"
import script from "./orderImport.vue?vue&type=script&lang=js&"
export * from "./orderImport.vue?vue&type=script&lang=js&"
import style0 from "./orderImport.vue?vue&type=style&index=0&id=0a6fe2a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6fe2a5",
  null
  
)

export default component.exports